import React, { useState } from "react";
import clsx from "clsx";
import {
  Button,
  FormControl,
  Select as SelectMui,
  MenuItem,
  InputLabel,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styles from "./documentAdded.module.scss";

function DocumentAdded({
  uploadFileDocument,
  documents,
  documentList,
}) {
  const [documentSelected, setDocumentSelected] = useState();

  const onHandleDocumentSelect = (e) => {
    const { value } = e.target;

    setDocumentSelected(value);
  };

  return (
    <fieldset className={styles.documentContainer}>
      <legend>Documentos</legend>
      <div className={styles.documentContainerList}>
        <div className={styles.documentSelector}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Documento</InputLabel>
            <SelectMui
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={documentSelected}
              label="Documento"
              onChange={onHandleDocumentSelect}
              className={styles.selectDoc}
            >
              {documentList.map((doc, idx) => {
                return (
                  <MenuItem
                    className={clsx({
                      [styles.uploadedDoc]: documents.find(
                        (d) => d.slug === doc.slug
                      ),
                    })}
                    key={`${doc.slug}-${idx}`}
                    value={doc.slug}
                  >
                    {doc.text}
                  </MenuItem>
                );
              })}
            </SelectMui>
          </FormControl>
        </div>
        <span className={styles.counterDoc}>
          <span className={styles.counterNumber}>{documents.length}/</span>
          {documentList.length}
        </span>

        {documentSelected &&
        !documents.find((d) => d.slug === documentSelected) ? (
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
          >
            Subir documento
            <input
              onChange={(e) =>
                uploadFileDocument(
                  e,
                  documentSelected,
                  documentList.find((d) => d.slug === documentSelected).text
                )
              }
              type="file"
              accept="image/*"
              required
              className={styles.upload_hidden_input}
            />
          </Button>
        ) : null}
      </div>
      {documents.find((d) => d.slug === documentSelected) ? (
        <div className={styles.docTable}>
          <div>
            {documentList.find((d) => d.slug === documentSelected).text}
          </div>
          <div>
            {documents
              .find((d) => d.slug === documentSelected)
              ?.updatedAt?.substring(0, 10)}
          </div>
          <div>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              Actualizar documento
              <input
                onChange={(e) =>
                  uploadFileDocument(
                    e,
                    documentSelected,
                    documentList.find((d) => d.slug === documentSelected).text
                  )
                }
                type="file"
                accept="image/*"
                required
                className={styles.upload_hidden_input}
              />
            </Button>
          </div>
        </div>
      ) : null}
    </fieldset>
  );
}

export default DocumentAdded;
